import React, { useEffect, useState, Fragment } from "react";
import { Form, InputGroup } from "react-bootstrap";

function PhoneInput({ onChange, errorFeedback, initialValue, ...props }) {
  const [prefix, setPrefix] = useState("+91");
  const [number, setNumber] = useState("");

  const prefixOnChangeHandler = (event) => {
    setPrefix(event.target.value);
  };

  const numberOnChangeHandler = (event) => {
    setNumber(event.target.value);
  };

  // Do not remove any of useEffect method until and unless you know why each of these are used.
  useEffect(() => {
    let phoneNumber = props.value.length === 10 ? props.value : number;
    setNumber(phoneNumber);
  }, []);

  useEffect(() => {
    let number = initialValue;
    if (number) {
      if (
        !number.includes("+91") &&
        !number.includes("+81") &&
        !number.includes("+92") &&
        !number.includes("+72") &&
        !number.includes("+52")
      ) {
        let phoneNumber = initialValue.length === 10 ? initialValue : number;
        setNumber(phoneNumber);
      }
    }
  }, [initialValue]);

  // useEffect(() => {
  //   let phoneNumber = props.value.length === 10 ? props.value : number;
  //   setNumber(phoneNumber);
  //   onChange(phoneNumber);
  // }, []);

  useEffect(() => {
    onChange(prefix + number);
  }, [number, prefix]);

  return (
    <Fragment>
      <InputGroup>
        <InputGroup.Prepend>
          <Form.Control
            as="select"
            custom
            className={"bg-light"}
            onChange={prefixOnChangeHandler}
          >
            <option>+91</option>
            <option>+81</option>
            <option>+92</option>
            <option>+72</option>
            <option>+52</option>
          </Form.Control>
        </InputGroup.Prepend>
        <Form.Control
          {...props}
          value={number}
          onChange={numberOnChangeHandler}
        />
        {errorFeedback}
      </InputGroup>
    </Fragment>
  );
}

export default PhoneInput;
